export default __webpack_public_path__ + "9a593dbc5dfe847f2e2d943019c8ac74.png";